import { Link } from "wouter";

interface RestoreLogoProps {
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  showTagline?: boolean;
  className?: string;
}

function LogoMark({ px }: { px: number }) {
  return (
    <img
      src="/favicon-192.png"
      alt="RestoreAI"
      width={px}
      height={px}
      style={{ borderRadius: 8, display: 'block' }}
    />
  );
}

export function RestoreLogo({
  size = 'md',
  href,
  onClick,
  showTagline = false,
  className = '',
}: RestoreLogoProps) {
  const cfg = {
    sm: { px: 32, titleSize: 14, subSize: 10, gap: 10 },
    md: { px: 36, titleSize: 15, subSize: 11, gap: 12 },
    lg: { px: 48, titleSize: 28, subSize: 13, gap: 14 },
  }[size];

  const inner = (
    <div
      className={`flex items-center select-none ${className}`}
      style={{ gap: cfg.gap, cursor: href || onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <div className="flex-shrink-0">
        <LogoMark px={cfg.px} />
      </div>
      <div>
        <div style={{ lineHeight: 1.2 }}>
          <span
            style={{
              fontSize: cfg.titleSize,
              fontWeight: 600,
              letterSpacing: '-0.02em',
              color: 'var(--restore-text-primary)',
            }}
          >
            Restore
          </span>
          <span
            style={{
              fontSize: cfg.titleSize,
              fontWeight: 800,
              letterSpacing: '-0.01em',
              color: 'var(--restore-accent)',
              marginLeft: 1,
            }}
          >
            AI
          </span>
        </div>
        {showTagline && (
          <p
            style={{
              fontSize: cfg.subSize,
              color: 'var(--restore-text-muted)',
              marginTop: 2,
            }}
          >
            AI-Powered Restoration
          </p>
        )}
      </div>
    </div>
  );

  if (href) {
    return <Link href={href}>{inner}</Link>;
  }
  return inner;
}
